import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useJBAuth } from '../auth';

/**
 * Wraps a page that requires an authenticated employer.
 * Redirects to /employer/login if not authenticated.
 */
export default function EmployerGuard({ children }) {
  const { token, role, loading } = useJBAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && (!token || role !== 'employer')) {
      navigate('/employer/login', { replace: true });
    }
  }, [token, role, loading, navigate]);

  if (loading) {
    return (
      <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'60vh', color:'#5a6373', fontFamily:'Inter,sans-serif' }}>
        Loading…
      </div>
    );
  }

  if (!token || role !== 'employer') return null;
  return children;
}
